module.exports = __webpack_public_path__ + "img/layers.ea54fee9.svg";